/**
 * Determina se um jogador deve estar mutado baseado no estado atual da conversa
 * @param {Object} currentState - Estado atual da conversa
 * @param {string} currentState.phase - Fase atual (FREE_CHAT, A_COMPLETING, etc.)
 * @param {string} currentState.lastCompleter - Último completador ('A' ou 'B')
 * @param {string} playerId - ID do jogador ('A', 'B', 'Host')
 * @returns {boolean} - true se o jogador deve estar mutado
 */
const AUTO_MUTE_ENABLED = false;

// eslint-disable-next-line import/prefer-default-export
export function shouldPlayerBeMuted(currentState, playerId) {
  if (!AUTO_MUTE_ENABLED) return false;
  if (!currentState || !playerId) return false;

  const { phase } = currentState;

  switch (phase) {
    case 'FREE_CHAT':
    case 'TRANSITIONING':
      return false; // Ninguém está mutado (todos podem falar)

    case 'WAITING_PARTNER':
    case 'WELCOME':
    case 'GROUND_RULES':
    case 'SELF_INTRODUCTIONS':
    case 'SELF_INTRODUCTIONS_A_TO_B':
      return true; // mutados

    case 'SELF_INTRODUCTIONS_A':
      return playerId !== 'A'; // Apenas jogador A pode falar (B mutado)

    case 'SELF_INTRODUCTIONS_B':
      return playerId !== 'B'; // Apenas jogador B pode falar (A mutado)

    case 'A_COMPLETING':
    case 'A_QUESTION':
      return playerId !== 'A'; // Apenas jogador A pode falar (B mutado)

    case 'B_COMPLETING':
    case 'B_QUESTION':
      return playerId !== 'B'; // Apenas jogador B pode falar (A mutado)

    default:
      return false; // Por padrão, não mutamos
  }
}
